import React, { useState } from "react";
import { iconData } from "../../../../../../iconData";
import MideaViewer from "../../../../../../midea_viewer/MideaViewer";
// css comes in PdfQTypeActivity.css
import { IP } from "./../../../../../../internalServer";
import { Card, IconButton, Typography, Box, Tooltip } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const PdfQTypeDRaft = ({
  setDraftAttach,
  editAttachData,
  updateActivity,
  attach,
}) => {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  console.log(attach, "attach");
  let attachments = Array.isArray(attach) ? attach : [attach];

  const attachformat = (para) => {
    if (para[0] !== undefined) {
      const filePath = para[0];
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };
  console.log(attachments, "attachments");
  const filePath = Array.isArray(attachments) ? attachments[0] : attachments;
  const ext = filePath?.split(".").pop()?.toLowerCase() || "";

  const isImage = ["jpg", "jpeg", "png"].includes(ext);
  const isVideo = ["mp4", "mov", "wmv", "mpeg"].includes(ext);
  const isPdf = ["pdf"].includes(ext);
  const isPpt = ["ppt", "pptx"].includes(ext);

  const isLink =
    filePath.startsWith("http://") || filePath.startsWith("https://");

  const handleOpen = () => {
    if (isLink) {
      window.open(filePath, "_blank"); // ✅ open in new tab
    } else if (isImage || isVideo) {
      handleClick(filePath);
    } else if (isPdf || isPpt) {
      handleClickforpdf(attachments);
    }
  };

  // let attachments = editAttachData?.attachments;
  return attach ? (
    <>
      {/* <div className="  all_pdf"
        onClick={() => {
          const fileType = attachments[0].split(".").pop();
          if (fileType === "jpg" || fileType === "jpeg" || fileType === "png" || fileType === "mp4"
            || fileType === "JPG" || fileType === "JPEG" || fileType === "PNG" || fileType === "MP4"
          ) {
            handleClick(attachments[0]);
          } else if (fileType === "pdf" || fileType === "PDF" || fileType === 'ppt' || fileType === 'PPT' || fileType === 'PPTX' || fileType === 'pptx') {
            handleClickforpdf(attachments[0]);
          }
        }}
      >

        <div className="pdf_logo">
          {console.log("attachments[0]", attachments[0])}
          <>
            {attachments[0].split(".").pop() === "jpg" ||
              attachments[0].split(".").pop() === "jpeg" ||
              attachments[0]?.split(".").pop() === "JPEG" ||
              attachments[0]?.split(".").pop() === "JPG" ||
              attachments[0]?.split(".").pop() === "PNG" ||
              attachments[0]?.split(".").pop() === "mp4" ||
              attachments[0]?.split(".").pop() === "MP4" ||
              attachments[0].split(".").pop() === "png" ? (
              <div
              
                onClick={() => {
                  if (!isError) {
                    handleClick(attachments[0]);
                    console.log("click")
                  }
                }}
                className="ContainerUploadedPdf d-flex gap-2 p-1"
              >
                <div className="d-flex align-items-center">
                  <img
                    src={`${iconData?.find(
                      (i) => i.extension === attachments[0]?.split(".").pop()
                    )?.icon
                      }`}
                    alt=""
                    className="attachLogoActivity"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center" onClick={() => handleClickforpdf(attachments[0])}>
                <img
                  className="extention_icon"
                  src={`${iconData?.find(
                    (i) =>
                      i.extension === attachments[0]?.match(/\.([^.]+)$/)[1]
                  )?.icon
                    }`}
                  alt=""
                />
              </div>
            )}
          </>
         
        </div>
        <div className="pdf_detail">
          <div className="d-flex align-itens-center justify-content-between">
            <span className="pdf-txt1">{editAttachData?.subject_id?.name}</span>
            <img
              className="cross"
              src="/images/cross.svg"
              alt=""
             
              onClick={(e) => setDraftAttach({ ...updateActivity, attach: "" })}
            />
          </div>
        
          <div className="pdf-txt2">
            {(attach && attach?.name) || attachformat(attachments)}
          </div>

        
        </div>
      </div> */}
      <Card
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.2,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          backgroundColor: "#fafafa",
          cursor: "pointer",
          "&:hover": {
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            backgroundColor: "#fff",
          },
          mb: 1.5,
        }}
      >
        {/* Left Section: File Icon + Info */}
        <Box display="flex" alignItems="center" gap={2}>
          {/* Dynamic File Icon */}
          <Box
            sx={{
              width: 42,
              height: 42,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              borderRadius: 1.5,
              overflow: "hidden",
            }}
          >
            <img
              src={
                filePath.startsWith("http://") ||
                filePath.startsWith("https://")
                  ? "/images/link-icon.png"
                  : iconData?.find(
                      (i) =>
                        i.extension.toLowerCase() ===
                        filePath?.split(".").pop()?.toLowerCase()
                    )?.icon || "/images/file-default.png"
              }
              alt=""
              className="attachLogoActivity"
            />
          </Box>

          {/* Text Info */}
          <Box>
            <Tooltip title={attachments}>
              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  maxWidth: 80,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {filePath.split("/").pop().replace(/^\d+_/, "")}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
        {/* Remove Button */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setDraftAttach((prev) => ({
              ...prev,
              attach: prev.attach.filter((a) => a !== attach),
            }));
          }}
        >
          <CloseRoundedIcon sx={{ color: "#b71c1c" }} />
        </IconButton>
      </Card>
      {mideaviewer && (
        <MideaViewer
          attachment={responseAttach}
          closeMideaviewer={setMideaviewer}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  {/* {console.log("1st")} */}
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* {console.log("2nd")} */}
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  ) : (
    <></>
  );
};

export default PdfQTypeDRaft;
